import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Banner.css';
import mosheurRahman from '../../../images/mosheur-rahman.jpg';
import {
  faFacebook,
  faLinkedinIn,
  faGithub,
  faYoutube,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Smoke from '../../Smoke/Smoke';

const Banner = ({ textEnter, textLeave, setCursorVariant }) => {
  const handleClick = (event) => {
    const smoke = document.createElement('div');
    smoke.className = 'smoke';
    smoke.style.top = `${event.clientY}px`;
    smoke.style.left = `${event.clientX}px`;
    document.body.appendChild(smoke);

    setTimeout(() => {
      smoke.remove();
    }, 2000);
  };

  return (
    <div className="banner-style" id="about">
      <Smoke />
      <Container>
        <Row className="align-items-center">
          <Col md={7} className="text-md-start pt-4">
            <h1 className="banner-title" onClick={handleClick}>
              About Me
            </h1>
            <h5
              style={{ textAlign: 'justify' }}
              className="mt-4 banner-detail mb-4"
              onClick={handleClick}
              onMouseEnter={textEnter}
              onMouseLeave={textLeave}>
              I am a highly motivated Full Stack Web Developer with an M.Sc. in
              Computer Science from University College Birmingham, UK. I
              specialise in creating high-performance React.js user interfaces
              and architecting scalable, RESTful backend services using Node.js
              and Express.js, with MongoDB for efficient data management. As a
              Lead Software Engineer at RozWeb Solution Ltd, I significantly
              honed my problem-solving, creative, and architecting abilities by
              personally designing, developing, and delivering custom web
              applications. My professional background includes experience as a
              Frontend Developer at Proxmed Pty Ltd, where I strengthened my
              expertise in building responsive, user-centric web interfaces. I
              am passionate about developing impactful web applications and
              continuously upskill to stay aligned with the latest industry
              trends and technologies.
            </h5>
            <div className="mb-4">
              <a
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                href="https://www.facebook.com/mosheur.pau"
                target="_blank"
                rel="noopener noreferrer"
                className="me-2 banner-icon-link ">
                <FontAwesomeIcon icon={faFacebook} className="banner-icon" />
              </a>
              <a
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                href="https://www.instagram.com/mosheur_mehedi"
                target="_blank"
                rel="noopener noreferrer"
                className="me-2 banner-icon-link">
                <FontAwesomeIcon icon={faInstagram} className="banner-icon" />
              </a>
              <a
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                href="https://github.com/mosheurpau"
                target="_blank"
                rel="noopener noreferrer"
                className="me-2 banner-icon-link">
                <FontAwesomeIcon icon={faGithub} className="banner-icon" />
              </a>
              <a
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                href="https://www.youtube.com/c/BasicProgrammer"
                target="_blank"
                rel="noopener noreferrer"
                className="me-2 banner-icon-link">
                <FontAwesomeIcon icon={faYoutube} className="banner-icon" />
              </a>
              <a
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                href="https://www.linkedin.com/in/mosheurrahman29/"
                target="_blank"
                rel="noopener noreferrer"
                className="banner-icon-link">
                <FontAwesomeIcon icon={faLinkedinIn} className="banner-icon" />
              </a>
            </div>
          </Col>
          <Col md={5} className="text-center mt-4 mt-md-0">
            <div className="banner-img-wrapper">
              <img
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                className="img-fluid p-2 banner-img"
                src={mosheurRahman}
                alt="img"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
